<template>
  <div class="col-md-4 col-sm-6 col-xs-12 event-item">
    <section class="panel panel-default m-n item_child">
      <a @click="goEvent(event.id)" class="block img-card item_url b-b b-light">
        <lazy-img alt="" class="item_avatar" :src="event.avatar"></lazy-img>
        <span v-if="event.privacy" class="text-black wrapper-sm pull-right" style="position: absolute; right: 10px; z-index: 99999;">
          <span class="item_privacy"> <i class="fa fa-lock text-muted"></i></span>
        </span>
      </a>
      <span class="item_status">
        <span v-if="status == 'upcoming'" class="label label-info pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">UPCOMING</span>
        <span v-if="status == 'thisweek'" class="label label-primary pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">THIS WEEK</span>
        <span v-if="status == 'ongoing'" class="label label-success pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">ONGOING</span>
        <span v-if="status == 'ended'" class="label label-danger pull-right m-t-n-sm text-u-c no-radius wrapper-xs" style="position: relative;">ENDED</span>
      </span>
      <div class="wrapper">
        <div style="height:40px; position: relative; overflow: hidden ">
          <a  @click="goEvent(event.id)" class="item_url">
            <div class="event-title">
              {{event.title}}
            </div>
          </a>
        </div>
      </div>

      <footer @click="goEvent(event.id)" class="panel-footer bg-light lter" style="cursor: pointer;">
        <div class="row no-padder">
          <div class="col-xs-10">
            <span class="block text-sm text-muted">
              <span class="text-muted m-r-xxs"><i class="fa fa-clock-o "></i></span>
              <span class="item_started">{{event.start_time | moment("DD MMM YYYY hh:mm A")}}</span>
            </span>
            <span class="block text-sm text-muted text-ellipsis">
              <span class="m-r-xs"><i class="fa fa-map-marker"></i> </span>
              <span class="item_short_address">
                <span v-if="event.city">{{event.city.name}}</span>
                <span v-if="event.country">  {{event.country.name}}</span>
              </span>
            </span>
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>

  import moment from 'moment-timezone';
  import shave from 'shave';

  export default {
    name: "event",
    data() {
      return {
        pageUrl: `${window.user.community_url}/${window.user.community_domain}/corporate#/view/${window.user.profile_id}/events`,
        icon: null,
        status: null              
      }
    },
    created() {
      this.getIcon();
      this.getStatus();
    },
    props: {
      event: null
    },
    watch: {
      event: function (to) {
        this.event = to;
      }
    },
    mounted() {
      shave('.event-title', 40, {character: '...'});
    },
    methods: {
      goOwner(id) {
        window.location.assign(`${window.user.community_url}/${window.user.community_domain}/profiles/view/${id}`);
      },
      goEvent(target) {
        window.location.assign(`${window.user.community_url}/${window.user.community_domain}/events/view/${target}?url=` + encodeURIComponent(this.pageUrl));
      },
      getIcon() {
        switch(this.event.owner_type) {
          case 'groups' :
              this.icon = '<i class="i i-users2"></i>';
            break;
          case 'profile' :
              this.icon = '<i class="fa fa-user"></i>';
            break;
          case 'organisation' :
              this.icon = '<i class="fa fa-building-o"></i>';
            break;
        }
      },
      getStatus() {
        const now = moment.now();
        const begin = this.event.start_time * 1000;
        const end = this.event.end_time * 1000;

        if (moment(now).isAfter(moment(begin)) && moment(now).isBefore(moment(end))){
          this.status = 'ongoing';
        } else if (moment(now).isAfter(moment(begin).subtract(7, 'days')) && moment(now).isBefore(moment(end))) {
          this.status = 'thisweek';
        } else if (moment(now).isBefore(moment(begin).subtract(7, 'days'))) {
          this.status = 'upcoming';
        } else {
          this.status = 'ended';
        }

      }
    }
  }
</script>

<style lang="scss">
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .lazy-image {
    max-width: 100% !important;
  }
  .item_status {
    position: absolute;
    z-index: 99999;
    right: 0px;
  }
  .event-owner {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    text-align: center;
    color: #000000;
  }
  .event-title {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #333333;
    height: 40px;
  }
  .event-item {
    margin: 0;
    padding: 0;
    display: block;
    width: 100%;
    &:hover {
      box-shadow: 0 5px 10px rgba(0,0,0,.1) !important;
    }
  }
</style>
